export const GTM_EVENTS = {
  purchase_success: `purchase_success`,
  user_sign_in: `user_sign_in`,
  purchase_cancel: `purchase_cancel`,
  purchase_ready_stripe_url: `purchase_ready_stripe_url`,
  purchase_try: `purchase_try`,
  purchase_error: `purchase_error`,
};
